import script from "./social.vue?vue&type=script&setup=true&lang=js"
export * from "./social.vue?vue&type=script&setup=true&lang=js"

import "./social.vue?vue&type=style&index=0&id=0a55763c&scoped=true&lang=css"

import exportComponent from "F:\\workspace\\custom\\sdxlxh\\ShanDongXinLiZiXun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a55763c"]])

export default __exports__